import Box from '@material-ui/core/Box';
import LinearProgress from '@material-ui/core/LinearProgress';
import { styled } from '@material-ui/core/styles';

export const FullPageContainer = styled(Box)(({ theme }) => ({
  height: '100vh',
  width: '100vw',
  display: 'grid',
  placeItems: 'center',
  backgroundColor: theme.palette.background.paper
}));

export const LoaderContainer = styled(Box)({
  height: 380,
  width: 380
});

export const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 6,
  borderRadius: 6,
  '&.MuiLinearProgress-colorPrimary': {
    backgroundColor: theme.palette.grey[300]
  },
  '& .MuiLinearProgress-bar': {
    borderRadius: 6,
    backgroundColor: theme.palette.brandColors.FPRed
  }
}));
